export default __webpack_public_path__ + "static/media/creative_directions_s.ab778653.jpg";